<template>
  <b-row class="share-card">
    <b-col cols="12" md="4" class="contact bg-light" v-if="contact">
      <div class="share-info">
        <img :src="`/static/images/avatars/main${contact.avatar || 1}.png`" class="contact-picture"/>
        <div class="contact-name"><b>{{ contact.fullName }}</b></div>
        <div class="jobTitle grey" v-if="contact.latestEmployment">
          {{contact.latestEmployment.title}} at <b>{{contact.latestEmployment.companyName}}</b>
        </div>
      </div>
    </b-col>
    <b-col cols="12" :md="modalSize">
      <share :title="job.title" :url="absoluteShareUrl" show-preview @track="trackShareClick">
        <template v-slot:text>
          <p>Share this role using your unique share link &amp; we'll track when {{ contact.fullName }} applies.</p>
        </template>
      </share>
    </b-col>
  </b-row>
</template>

<script>
import ls from 'local-storage';
import Share from '@/components/Share';
import parseDate from 'date-fns/parse';
import { getShareURL } from '@/lib/share';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'ContactShare',
  props: {
    eventName: {
      type: String,
      default: () => 'JOB_SHARED',
    },
    shareCode: {
      type: String,
    },
    contact: {
      type: Object,
    },
    job: {
      type: Object,
    },
  },
  components: {
    Share,
  },
  computed: {
    ...mapRoot([ 'company' ]),
    absoluteShareUrl() {
      return `${window.location.origin}/r/${this.shareCode}`;
    },
    // TODO make it REGISTER_NETWORK_PAGE_DESCRIPTION
    noSharePrefs() {
      return Object.keys(this.company.sharePreferences).reduce((bool, key) => {
        return key !== '__typename' ? bool && this.company.sharePreferences[key] === false : bool;
      }, true);
    },
    modalSize() {
      if (this.contact) {
        return 8;
      } else {
        return 12;
      }
    }
  },
  methods: {
    getChannelShareUrl(channel) {
      try {
        return getShareURL(this.$i18n, {
          channel,
          company: this.company,
          job: this.job,
          contact: this.contact,
          shareUrl: this.absoluteShareUrl,
          userAgent: (() => {
            try {
              if (process.env.VUE_ENV === 'server') {
                const { reqHeaders } = this.$ssrContext;
                return reqHeaders['User-Agent'] || reqHeaders['user-agent'] || null;
              } else if (process.env.VUE_ENV === 'client') {
                const { navigator } = window;
                return navigator.userAgent;
              } else {
                return null;
              }
            } catch (err) {
              this.$log.error(err);
              return null;
            }
          })(),
        });
      } catch (err) {
        console.error(err);
        return this.absoluteShareUrl;
      }
    },
    trackShareClick({ channel }) {
      Promise.resolve(this.$root.captureLog({
        eventName: this.eventName,
        job: { share: this.shareCode },
        user: { share: this.shareCode },
        referral: { share: this.shareCode },
        data: channel ? [ { key: 'channel', value: channel } ] : null,
      }));
      this.shareCapWarning();
    },
    shareCapWarning() {
      const now = Date.now();
      const timeLimit = 60 * 60 * 24 * 1000;
      const countLimit = 30;
      let shareCap = ls.get('shareCap');
      if (!shareCap || now - shareCap.started > timeLimit) {
        shareCap = { count: 0, started: now };
      }
      shareCap.count += 1;
      if (shareCap.count > countLimit && now - shareCap.started <= timeLimit) {
        // eslint-disable-next-line
        this.$bvModal.msgBoxOk("Hi there - you've been busy referring today which is great but it does seem unusually high. It's important you make genuine referrals or we'll have to notify your HR team. Thanks!", {
          title: 'Unusual activity',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          headerClass: 'p-3 border-bottom-0',
          bodyClass: 'p-3',
          footerClass: 'p-3 border-top-0',
          centered: true
        });
        Promise.resolve(this.$root.captureLog({
          eventName: `${this.eventName}_WARNING`,
          data: [
            { key: 'started', value: `${parseDate(shareCap.started)}` },
            { key: 'count', value: `${shareCap.count}` },
          ],
        }));
      }
      ls('shareCap', shareCap);
    }
  },
};
</script>

<style lang="scss">
.share-card {
  margin-bottom: 1rem;

  .share-again {
    h3  {
      display: block;
      margin: 0 auto;
    }
    text-align: center;
    p {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/share.vue